const map = {
	"./0/Kambi/HomeSection.layout.js": [
		48995,
		[
			2022,
			1754
		]
	],
	"./0/Poker/HomeSection.layout.js": [
		63170,
		[
			2022,
			3123
		]
	],
	"./0/Spectate/HomeSection.layout.js": [
		86434,
		[
			2022,
			4923
		]
	],
	"./1/Kambi/HomeSection.layout.js": [
		94398,
		[
			2022,
			4935
		]
	],
	"./1/Poker/HomeSection.layout.js": [
		51835,
		[
			2022,
			3478
		]
	],
	"./1/Spectate/HomeSection.layout.js": [
		75701,
		[
			2022,
			926
		]
	],
	"./31/Kambi/HomeSection.layout.js": [
		90011,
		[
			2022,
			4666
		]
	],
	"./31/Poker/HomeSection.layout.js": [
		3786,
		[
			2022,
			8597
		]
	],
	"./31/Spectate/HomeSection.layout.js": [
		88570,
		[
			2022,
			4397
		]
	],
	"./58/Spectate/HomeSection.layout.js": [
		47911,
		[
			2022,
			9858
		]
	],
	"./75/Kambi/HomeSection.layout.js": [
		62195,
		[
			2022,
			1938
		]
	],
	"./75/Spectate/HomeSection.layout.js": [
		62258,
		[
			2022,
			781
		]
	],
	"./76/Kambi/HomeSection.layout.js": [
		32416,
		[
			2022,
			4749
		]
	],
	"./76/Spectate/HomeSection.layout.js": [
		94835,
		[
			2022,
			5346
		]
	],
	"./8/Poker/HomeSection.layout.js": [
		13834,
		[
			2022,
			5915
		]
	],
	"./8/Spectate/HomeSection.layout.js": [
		83866,
		[
			2022,
			4419
		]
	],
	"./81/Kambi/HomeSection.layout.js": [
		70646,
		[
			2022,
			5239
		]
	],
	"./81/Spectate/HomeSection.layout.js": [
		61325,
		[
			2022,
			3556
		]
	],
	"./84/Kambi/HomeSection.layout.js": [
		49999,
		[
			2022,
			6134
		]
	],
	"./84/Spectate/HomeSection.layout.js": [
		4145,
		[
			2022,
			6485
		]
	],
	"./86/Spectate/HomeSection.layout.js": [
		72540,
		[
			2022,
			3287
		]
	],
	"./87/Spectate/HomeSection.layout.js": [
		86303,
		[
			2022,
			6250
		]
	],
	"./88/Spectate/HomeSection.layout.js": [
		93218,
		[
			2022,
			6969
		]
	],
	"./89/Spectate/HomeSection.layout.js": [
		78389,
		[
			2022,
			748
		]
	],
	"./90/Spectate/HomeSection.layout.js": [
		69707,
		[
			2022,
			2486
		]
	],
	"./91/Spectate/HomeSection.layout.js": [
		76184,
		[
			2022,
			1811
		]
	],
	"./92/Spectate/HomeSection.layout.js": [
		39549,
		[
			2022,
			7396
		]
	],
	"./94/Spectate/HomeSection.layout.js": [
		82927,
		[
			2022,
			2506
		]
	],
	"./95/Spectate/HomeSection.layout.js": [
		41068,
		[
			2022,
			4215
		]
	],
	"./96/Poker/HomeSection.layout.js": [
		92431,
		[
			2022,
			4464
		]
	],
	"./96/Spectate/HomeSection.layout.js": [
		27617,
		[
			2022,
			8411
		]
	],
	"./default/Kambi/HomeSection.layout.js": [
		30012,
		[
			2022,
			5841
		]
	],
	"./default/Spectate/HomeSection.layout.js": [
		70767,
		[
			2022,
			7968
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7328;
module.exports = webpackAsyncContext;